export default __webpack_public_path__ + "static/media/greec.be688fc9.svg";